import { Injectable } from '@angular/core';
import { DialogsConfigService } from '../dialogs-config.service';
import { RxTextCompositeComponent } from '@nrwl/rx-forms';

@Injectable({
  providedIn: 'root',
})
export class TwoFaDialogConfigService extends DialogsConfigService {
  constructor() {
    super();
  }

  public noAttemptsLeft() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Alert',
        tip: `There are no attempts left. Please contact your clinic to resend the forms.`,
        buttons: this.SubmitDismissButtons('Ok'),
      },
    };
  }

  public codeHasExpired() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Alert',
        tip: `Previous code has expired. Please request a new code. Code expires after 15 minutes.`,
        buttons: this.SubmitDismissButtons('Request Code'),
      },
    };
  }

  public tooManyAttemps() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Alert',
        tip: `Previous code has expired. Please request a new code. Code expires after 15 minutes.`,
        buttons: this.SubmitDismissButtons('Request Code'),
      },
    };
  }

  public customAlert(text) {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Alert',
        tip: text,
        buttons: this.SubmitDismissButtons('Ok'),
      },
    };
  }
}
